export default __webpack_public_path__ + "static/media/birth-control-request.b4ca9c43.png";